import { Component, Input } from '@angular/core';

import { Usuario } from '../../usuario';

@Component({
    selector: 'sgt-usuario-permissao-cadastro',
    templateUrl: './usuario-permissao-cadastro.component.html',
    styleUrls: ['./usuario-permissao-cadastro.component.less']
})
export class UsuarioPermissaoCadastroComponent {
    @Input() entity: Usuario;
}
